import { saveProductAlertPreferences, saveSavedSearchAlertPreferences } from '../services/my-alert-api.js';

// Track which tables have changes
var hasProductChanges = false;
var hasSavedSearchChanges = false;
var currentAllFrequency = 'NONE';
var isCustomOverride = false;

function getProductRowIndex(row) {
  var hiddenInput = row.find('input[type="hidden"][id*="ProductAlerts"][id$=".Product"]');
  if (hiddenInput.length) {
    var match = hiddenInput.attr('id').match(/ProductAlerts\[(\d+)\]\.Product/);
    if (match) {
      return parseInt(match[1], 10);
    }
  }

  return row.index();
}

function resolveProductId(row, checkbox) {
  var hiddenInput = row.find('input[type="hidden"][id*="ProductAlerts"][id$=".Product"]');
  if (hiddenInput.length) {
    return hiddenInput.val();
  }

  if (checkbox && checkbox.length) {
    return (
      checkbox.data('productId') ||
      checkbox.data('productCode') ||
      checkbox.attr('data-product-id') ||
      checkbox.attr('data-product-code') ||
      checkbox.attr('id') ||
      ''
    );
  }

  return '';
}

function isProductRow(row) {
  return row.find('input[type="hidden"][id*="ProductAlerts"][id$=".Product"]').length > 0;
}

function isSavedSearchRow(row) {
  return row.find('input.saved-search-checkbox').length > 0 && row.find('input[id$="Id"]').length > 0;
}

function syncSelectAllCheckbox() {
  var selectAll = $('#selectAllProducts');
  if (!selectAll.length) {
    return;
  }

  var productRows = $('.subscription-products-sub-table tbody tr').filter(function() {
    return isProductRow($(this));
  });
  if (!productRows.length) {
    selectAll.prop('checked', false).removeAttr('checked');
    return;
  }

  var allChecked = true;
  productRows.each(function() {
    var row = $(this);
    var checkbox = row.find('input.product-checkbox');
    if (!checkbox.is(':checked')) {
      allChecked = false;
      return false;
    }
  });

  selectAll.prop('checked', allChecked);
  if (allChecked) {
    selectAll.attr('checked', 'checked');
  } else {
    selectAll.removeAttr('checked');
  }
}

function syncSelectAllSavedSearches() {
  var selectAll = $('#selectAllSavedSearches');
  if (!selectAll.length) {
    return;
  }

  var savedRows = $('.saved-searches-box tbody tr').filter(function() {
    return isSavedSearchRow($(this));
  });

  if (!savedRows.length) {
    selectAll.prop('checked', false).removeAttr('checked');
    return;
  }

  var allChecked = true;
  savedRows.each(function() {
    var row = $(this);
    var checkbox = row.find('input.saved-search-checkbox');
    if (!checkbox.is(':checked')) {
      allChecked = false;
      return false;
    }
  });

  selectAll.prop('checked', allChecked);
  if (allChecked) {
    selectAll.attr('checked', 'checked');
  } else {
    selectAll.removeAttr('checked');
  }
}

function setCustomControlsDisabled(disabled) {
  $('.subscription-products-sub-table tbody tr').each(function() {
    var row = $(this);
    if (!isProductRow(row)) {
      return;
    }
    var checkbox = row.find('input[type="checkbox"]');
    checkbox.prop('disabled', disabled);

    var rowIndex = getProductRowIndex(row);
    var radioName = 'ProductAlerts' + rowIndex;
    row
      .find('input[name="' + radioName + '"]')
      .prop('disabled', disabled);
  });
}

function updateRowInactiveState(row) {
  if (!isProductRow(row)) {
    return;
  }

  var checkbox = row.find('input[type="checkbox"]');
  var isChecked = checkbox.is(':checked');
  var rowIndex = getProductRowIndex(row);
  var radioName = 'ProductAlerts' + rowIndex;
  var radios = row.find('input[name="' + radioName + '"]');
  var selectedRadio = radios.filter(':checked');

  if (isChecked) {
    checkbox.attr('checked', 'checked');
    row.removeClass('inactive-alert');
    radios.prop('disabled', false);
    radios.each(function() {
      var radio = $(this);
      radio.closest('.labeled-checkbox').find('label').removeClass('disabled');
    });
    if (!selectedRadio.length) {
      var freq = currentAllFrequency !== 'NONE' ? currentAllFrequency : 'WEEKLY';
      radios.filter('[value="' + freq + '"]').prop('checked', true);
    }
  } else {
    checkbox.prop('checked', false);
    checkbox.removeAttr('checked');
    row.addClass('inactive-alert');
    radios.prop('checked', false);
    radios.prop('disabled', true);
    radios.each(function() {
      var radio = $(this);
      radio.closest('.labeled-checkbox').find('label').addClass('disabled');
    });
  }
}

function updateSavedSearchRowState(row) {
  if (!isSavedSearchRow(row)) {
    return;
  }

  var checkbox = row.find('input.saved-search-checkbox');
  var isChecked = checkbox.is(':checked');
  var radios = row.find('input.saved-search-frequency');

  if (isChecked) {
    checkbox.attr('checked', 'checked');
    row.removeClass('inactive-alert saved-search-no-alert');
    radios.prop('disabled', false);
    radios.each(function() {
      var radio = $(this);
      radio.closest('.labeled-checkbox').find('label').removeClass('disabled');
    });

    var selected = radios.filter(':checked');
    if (!selected.length && radios.length) {
      radios.filter('[value="WEEKLY"]').prop('checked', true).attr('checked', 'checked');
    }
  } else {
    checkbox.prop('checked', false).removeAttr('checked');
    row.addClass('inactive-alert saved-search-no-alert');
    radios.prop('checked', false).prop('disabled', true).removeAttr('checked');
    radios.each(function() {
      var radio = $(this);
      radio.closest('.labeled-checkbox').find('label').addClass('disabled');
    });
  }
}

function applyAllNone() {
  $('.custom-products-row').hide();
  $('#activateCustomSubscriptionServices').prop('checked', false);
  $('.subscription-products-sub-table tbody tr').each(function() {
    var row = $(this);
    if (!isProductRow(row)) {
      return;
    }
    var checkbox = row.find('input[type="checkbox"]');
    checkbox.prop({ checked: false, disabled: true });
    checkbox.removeAttr('checked');

    var rowIndex = getProductRowIndex(row);
    var radioName = 'ProductAlerts' + rowIndex;
    var radios = row.find('input[name="' + radioName + '"]');
    radios.prop({ checked: false, disabled: true });
    radios.removeAttr('checked');

    row.addClass('inactive-alert');
  });

  syncSelectAllCheckbox();
}

function applyAllFrequency(freq) {
  $('.custom-products-row').hide();
  $('#activateCustomSubscriptionServices').prop('checked', false);
  setCustomControlsDisabled(false);
  $('.subscription-products-sub-table tbody tr').each(function() {
    var row = $(this);
    if (!isProductRow(row)) {
      return;
    }
    var checkbox = row.find('input[type="checkbox"]');
    
    // Explicitly check the checkbox and ensure it's enabled
    // Use both prop and attr to ensure visual state updates
    checkbox.prop('checked', true);
    checkbox.prop('disabled', false);
    checkbox.attr('checked', 'checked');
    
    var rowIndex = getProductRowIndex(row);
    var radioName = 'ProductAlerts' + rowIndex;
    var radios = row.find('input[name="' + radioName + '"]');
    radios.prop('disabled', false);
    radios.prop('checked', false);
    radios.removeAttr('checked');
    radios.filter('[value="' + freq + '"]').prop('checked', true).attr('checked', 'checked');

    row.removeClass('inactive-alert');
  });

  syncSelectAllCheckbox();
  setTimeout(sortProducts, 100);
}

function enterCustomOverrideMode() {
  if (isCustomOverride) {
    return;
  }

  isCustomOverride = true;
  $('#activateAllSubscriptionServices').prop('checked', false);
  $('input[name="allProductsFrequency"]').prop('disabled', true);
  $('#activateCustomSubscriptionServices').prop('checked', true);
  setCustomControlsDisabled(false);

  $('.subscription-products-sub-table tbody tr').each(function() {
    var row = $(this);
    if (!isProductRow(row)) {
      return;
    }
    updateRowInactiveState(row);
  });
}

function exitCustomOverrideMode() {
  if (!isCustomOverride) {
    $('input[name="allProductsFrequency"]').prop('disabled', false);
    return;
  }

  isCustomOverride = false;
  $('input[name="allProductsFrequency"]').prop('disabled', false);
}

function evaluateCustomState() {
  if (!$('#activateAllSubscriptionServices').is(':checked')) {
    return;
  }

  var freq = currentAllFrequency;
  var mismatch = false;

  $('.subscription-products-sub-table tbody tr').each(function() {
    var row = $(this);
    if (!isProductRow(row)) {
      return;
    }
    var checkbox = row.find('input[type="checkbox"]');
    var rowIndex = getProductRowIndex(row);
    var radioName = 'ProductAlerts' + rowIndex;
    var selectedRadio = row.find('input[name="' + radioName + '"]:checked');
    var rowFrequency = selectedRadio.length ? selectedRadio.val() : null;

    if (freq === 'NONE') {
      if (checkbox.is(':checked') || rowFrequency) {
        mismatch = true;
        return false;
      }
    } else {
      if (!checkbox.is(':checked') || rowFrequency !== freq) {
        mismatch = true;
        return false;
      }
    }
  });

  if (mismatch) {
    enterCustomOverrideMode();
  } else {
    exitCustomOverrideMode();
  }

  syncSelectAllCheckbox();
}

function initializeProductAlertState() {
  var initialFreq = $('input[name="allProductsFrequency"]:checked').val() || 'NONE';
  currentAllFrequency = initialFreq;

  if ($('#activateAllSubscriptionServices').is(':checked')) {
    if (initialFreq === 'NONE') {
      applyAllNone();
    } else {
      applyAllFrequency(initialFreq);
    }
    exitCustomOverrideMode();
  } else {
    setCustomControlsDisabled(false);
    enterCustomOverrideMode();
    // Show if custom radio is selected on page load
    if ($('#activateCustomSubscriptionServices').is(':checked')) {
      $('.custom-products-row').show();
    } else {
      $('.custom-products-row').hide();
    }
  }

  $('.subscription-products-sub-table tbody tr').each(function() {
    updateRowInactiveState($(this));
  });

  evaluateCustomState();
  syncSelectAllCheckbox();
}

$(function () {
  var inputs = $('input[type="radio"]');

  // Enable save button when any radio button changes in subscription services table
  $('.subscription-products-sub-table input[type="radio"]').change(function () {
    $("#saveChangesBtn").removeAttr("disabled");
    hasProductChanges = true;

    var row = $(this).closest('tr');
    var checkbox = row.find('input[type="checkbox"]');
    if (!checkbox.is(':checked')) {
      checkbox.prop('checked', true);
      checkbox.attr('checked', 'checked');
    }
    updateRowInactiveState(row);

    setCustomControlsDisabled(false);
    evaluateCustomState();
  });

  // Enable save button when any radio button changes in saved searches table
  $('.saved-searches-box input[type="radio"]').change(function () {
    $("#saveChangesBtn").removeAttr("disabled");
    hasSavedSearchChanges = true;

    var row = $(this).closest('tr');
    if (isSavedSearchRow(row)) {
      var checkbox = row.find('input.saved-search-checkbox');
      checkbox.prop('checked', true).attr('checked', 'checked');
      updateSavedSearchRowState(row);
      syncSelectAllSavedSearches();
    }
  });

  // Enable save button when "Activate all" radio changes
  $('#activateAllSubscriptionServices').change(function() {
    $("#saveChangesBtn").removeAttr("disabled");
    hasProductChanges = true;

    if ($(this).is(':checked')) {
      var freq = $('input[name="allProductsFrequency"]:checked').val() || 'NONE';
      currentAllFrequency = freq;
      $('#activateCustomSubscriptionServices').prop('checked', false);
      exitCustomOverrideMode();

      if (freq === 'NONE') {
        applyAllNone();
      } else {
        applyAllFrequency(freq);
      }
    }
  });

  // Enable save button when "Custom" radio changes
  $('#activateCustomSubscriptionServices').change(function() {
    $("#saveChangesBtn").removeAttr("disabled");
    hasProductChanges = true;

    if ($(this).is(':checked')) {
      enterCustomOverrideMode();
    } else {
      var freq = $('input[name="allProductsFrequency"]:checked').val() || 'NONE';
      currentAllFrequency = freq;
      $('#activateAllSubscriptionServices').prop('checked', true);
      exitCustomOverrideMode();

      if (freq === 'NONE') {
        applyAllNone();
      } else {
        applyAllFrequency(freq);
      }
    }
  });

  // Enable save button when frequency changes in "Activate all" row (NONE/DAILY/WEEKLY/MONTHLY)
  $('input[name="allProductsFrequency"]').change(function() {
    var selectedFrequency = $(this).val();
    currentAllFrequency = selectedFrequency;

    $("#saveChangesBtn").removeAttr("disabled");
    hasProductChanges = true;

    $('#activateAllSubscriptionServices').prop('checked', true);
    $('#activateCustomSubscriptionServices').prop('checked', false);

    if (selectedFrequency === 'NONE') {
      applyAllNone();
    } else {
      applyAllFrequency(selectedFrequency);
    }

    exitCustomOverrideMode();
  });

  // Handle checkbox changes for product selection
  $('.subscription-products-sub-table input[type="checkbox"]').change(function() {
    $("#saveChangesBtn").removeAttr("disabled");
    hasProductChanges = true;

    setCustomControlsDisabled(false);

    var checkboxInput = $(this);
    var row = checkboxInput.closest('tr');

    if (!isProductRow(row)) {
      var isChecked = checkboxInput.is(':checked');
      $('.subscription-products-sub-table tbody tr').each(function() {
        var productRow = $(this);
        if (!isProductRow(productRow)) {
          return;
        }

        var productCheckbox = productRow.find('input[type="checkbox"]');
        productCheckbox.prop('checked', isChecked);
        productCheckbox.prop('disabled', false);

        if (isChecked) {
          productCheckbox.attr('checked', 'checked');
        } else {
          productCheckbox.removeAttr('checked');
        }

        updateRowInactiveState(productRow);
      });

      evaluateCustomState();
      syncSelectAllCheckbox();
      return;
    }

    updateRowInactiveState(row);
    evaluateCustomState();
    syncSelectAllCheckbox();
    setTimeout(sortProducts, 100);
  });

  // Handle checkbox changes for saved search selection
  $('.saved-searches-box input[type="checkbox"]').change(function() {
    $("#saveChangesBtn").removeAttr("disabled");
    hasSavedSearchChanges = true;

    var checkboxInput = $(this);
    var row = checkboxInput.closest('tr');

    if (!isSavedSearchRow(row)) {
      var isChecked = checkboxInput.is(':checked');
      $('.saved-searches-box tbody tr').each(function() {
        var savedRow = $(this);
        if (!isSavedSearchRow(savedRow)) {
          return;
        }

        var savedCheckbox = savedRow.find('input.saved-search-checkbox');
        savedCheckbox.prop('checked', isChecked);
        savedCheckbox.prop('disabled', false);

        if (isChecked) {
          savedCheckbox.attr('checked', 'checked');
        } else {
          savedCheckbox.removeAttr('checked');
        }

        updateSavedSearchRowState(savedRow);
      });

      syncSelectAllSavedSearches();
      return;
    }

    updateSavedSearchRowState(row);
    syncSelectAllSavedSearches();
    setTimeout(sortSavedSearches, 100);
  });

  initializeProductAlertState();
  $('.saved-searches-box tbody tr').each(function() {
    updateSavedSearchRowState($(this));
  });
  syncSelectAllSavedSearches();
  
  // Initial sort on page load
  sortProducts();
  sortSavedSearches();
  
  // --- Show All / Hide toggle ---
  $(document).on('click', '.show-all-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $btn = $(this);
    var $customRow = $('.custom-products-row');
    var isVisible = $customRow.is(':visible');

    if (isVisible) {
      $customRow.hide();
      // Update button text while preserving SVG icon
      var $icon = $btn.find('svg');
      $btn.text('Show All ').append($icon);
    } else {
      $customRow.show();
      // Update button text while preserving SVG icon
      var $icon = $btn.find('svg');
      $btn.text('Hide ').append($icon);
    }
  });
});

// ========== Sorting Functions ==========

function sortTableRows($tbody) {
  var $rows = $tbody.find('tr').get();
  
  $rows.sort(function(a, b) {
    var aChecked = $(a).find('input[type="checkbox"]').is(':checked');
    var bChecked = $(b).find('input[type="checkbox"]').is(':checked');
    var aName = $(a).find('td').eq(1).text().trim();
    var bName = $(b).find('td').eq(1).text().trim();
    
    // Active alerts first, then alphabetically
    if (aChecked !== bChecked) return bChecked - aChecked;
    return aName.localeCompare(bName);
  });
  
  $rows.forEach(function(row) {
    $tbody.append(row);
  });
}

function sortProducts() {
  var $tbody = $('.subscription-products-sub-table tbody');
  if ($tbody.length) {
    sortTableRows($tbody);
  }
}

function sortSavedSearches() {
  var $tbody = $('.saved-searches-box table tbody');
  if ($tbody.length) {
    sortTableRows($tbody);
  }
}

/**
 * Collects form data from subscription products table
 * Returns array of product alert objects
 * Logic: Checkbox checked = enabled with frequency, unchecked = disabled (NONE)
 */
function getSubscriptionProductsData() {
  var productsData = [];
  var counter = 0;

  // Check if "Activate all" is selected
  var activateAll = $('#activateAllSubscriptionServices').is(':checked');
  
  if (activateAll) {
    // Get frequency from "Activate all" row
    var allFrequencyRadio = $('input[name="allProductsFrequency"]:checked');
    var allFrequency = allFrequencyRadio.length > 0 ? allFrequencyRadio.val() : 'WEEKLY';
    
    // Apply same frequency to all products
    $('.subscription-products-sub-table tbody tr').each(function() {
      var row = $(this);
      if (!isProductRow(row)) {
        return;
      }
      var checkbox = row.find('input[type="checkbox"]');
      
      if (checkbox.length > 0) {
        var productName = row.find('td:eq(1)').text().trim();
        var serviceArea = row.find('td:eq(2)').text().trim();
        
        var productId = resolveProductId(row, checkbox);
        
        productsData.push({
          Product: productId, // Get from hidden input
          Title: productName,
          ServiceArea: serviceArea,
          Frequency: allFrequency,
          AlertEnabled: allFrequency !== 'NONE', // False when NONE, true otherwise
          IsChecked: true
        });
      }
    });
  } else {
    // Custom selection - include ALL products, but only checked ones are enabled
    $('.subscription-products-sub-table tbody tr').each(function() {
      var row = $(this);
      if (!isProductRow(row)) {
        return;
      }
      var checkbox = row.find('input[type="checkbox"]');
      
      if (checkbox.length > 0) {
        var productName = row.find('td:eq(1)').text().trim();
        var serviceArea = row.find('td:eq(2)').text().trim();
        
        var productId = resolveProductId(row, checkbox);
        
        var isChecked = checkbox.is(':checked');
        
        // Get the selected frequency for this specific product
        var rowIndex = getProductRowIndex(row);
        var radioName = 'ProductAlerts' + rowIndex;
        var frequencyRadio = row.find('input[name="' + radioName + '"]:checked');
        if (!frequencyRadio.length) {
          frequencyRadio = row.find('input.product-frequency:checked');
        }
        var frequency = frequencyRadio.length > 0 ? frequencyRadio.val() : 'NONE';
        
        productsData.push({
          Product: productId, // Get from hidden input
          Title: productName,
          ServiceArea: serviceArea,
          Frequency: isChecked ? frequency : 'NONE', // If unchecked, set to NONE
          AlertEnabled: isChecked, // Enabled only if checkbox is checked
          IsChecked: isChecked
        });
      }
    });
  }
  
  return productsData;
}

/**
 * Collects form data from saved searches table
 * Returns URL-encoded string for SavedSearches API
 * Logic: Checkbox checked = enabled with frequency, unchecked = disabled (NONE)
 */
function getSavedSearchesData() {
  var urlEncodedData = new URLSearchParams();
  var counter = 0;

  $('.saved-searches-box tbody tr').each(function() {
    var row = $(this);
    if (!isSavedSearchRow(row)) {
      return;
    }
    var checkbox = row.find('input[type="checkbox"]');
    
    // Include ALL saved searches (both checked and unchecked)
    if (checkbox.length > 0) {
      // Get data from hidden inputs
      var titleInput = row.find('input[id$="Title"]');
      var urlInput = row.find('input[id$="Url"]');
      var alertEnabledInput = row.find('input[id$="AlertEnabled"]');
      var idInput = row.find('input[id$="Id"]');
      
      if (titleInput.length > 0) {
        var title = titleInput.val();
        var url = urlInput.val();
        var id = idInput.val();
        var isChecked = checkbox.is(':checked');
        
        // Get selected frequency from radio buttons
        var frequencyRadio = row.find('input[type="radio"]:checked');
        var frequency = frequencyRadio.length > 0 ? frequencyRadio.val() : 'NONE';
        
        // If checkbox is unchecked, set frequency to NONE and AlertEnabled to false
        var finalFrequency = isChecked ? frequency : 'NONE';
        var alertEnabled = isChecked;
        
        // Add to form data
        urlEncodedData.append("SavedSearchInputs[" + counter + "].Title", title);
        urlEncodedData.append("SavedSearchInputs[" + counter + "].Url", url);
        urlEncodedData.append("SavedSearchInputs[" + counter + "].AlertEnabled", alertEnabled ? 'true' : 'false');
        urlEncodedData.append("SavedSearchInputs[" + counter + "].Id", id);
        urlEncodedData.append("SavedSearchInputs[" + counter + "].Frequency", finalFrequency);
        
        counter++;
      }
    }
  });
  
  return urlEncodedData.toString();
}

/**
 * Main submit function that handles both products and saved searches
 * Only calls APIs for tables that have changes
 */
function submitAllPreferences() {
  window.INFORMA.Spinner.Show($('body')); // Show the spinner
  
  // Hide previous messages
  $('.alert-message').hide();
  
  var promises = [];
  
  // Only submit products preferences if there are changes in product table
  if (hasProductChanges) {
    var productsData = getSubscriptionProductsData();
    if (productsData.length > 0) {
      promises.push(saveProductAlertPreferences(productsData));
    }
  }
  
  // Only submit saved searches preferences if there are changes in saved search table
  if (hasSavedSearchChanges) {
    var savedSearchesData = getSavedSearchesData();
    if (savedSearchesData.length > 0) {
      promises.push(saveSavedSearchAlertPreferences(savedSearchesData));
    }
  }
  
  // If no changes were made, show message
  if (promises.length === 0) {
    window.INFORMA.Spinner.Hide();
    console.warn('No changes detected');
    return Promise.resolve();
  }
  
  // Wait for all API calls to complete
  return Promise.all(promises)
    .then(function(results) {
      window.INFORMA.Spinner.Hide(); // Hide the spinner
      
      // Check if all results are successful
      var allSuccessful = results.every(function(result) {
        return result.success === true;
      });
      
      if (allSuccessful) {
        // $('.alert-message-success').show();
        toaster.success('Preferences saved successfully!');
        
        // Reset change tracking flags
        hasProductChanges = false;
        hasSavedSearchChanges = false;
        
        // Disable the save button again
        $('#saveChangesBtn').attr('disabled', 'disabled');
        
        // Reload page to reflect changes (unless navigation is pending)
        if (!window.__skipAutoReloadForNavigation) {
          setTimeout(function() {
            window.location.reload();
          }, 1500);
        }
      } else {
        // $('.alert-message-error').show();
        
        // Show error details if available
        var errorMessages = results
          .filter(function(result) { return !result.success; })
          .map(function(result) { return result.message || result.error; })
          .join(', ');
        
        if (errorMessages) {
          console.error('API Errors:', errorMessages);
        }
        
        // setTimeout(function() {
        //   $('.alert-message-error').fadeOut();
        // }, 5000);

        toaster.error(errorMessages || 'An error occurred while saving preferences.');
      }
    })
    .catch(function(error) {
      window.INFORMA.Spinner.Hide(); // Hide the spinner
      console.error('Error:', error);
      $('.alert-message-error').show();
      // setTimeout(function() {
      //   $('.alert-message-error').fadeOut();
      // }, 5000);
    });
}

// Initialize on document ready
document.addEventListener('DOMContentLoaded', function() {
  var saveButton = document.getElementById('saveChangesBtn');
  
  if (saveButton != null) {
    // Initially disable the button
    saveButton.setAttribute('disabled', 'disabled');
    
    // Add click handler
    saveButton.addEventListener('click', function(event) {
      event.preventDefault();
      submitAllPreferences();
    });
  }
  
  // Handle "Activate all" vs "Custom" radio selection
  $('input[name="subscriptionServiceType"]').on('change', function() {
    var $showAllBtn = $('.show-all-btn');
    var $customRow = $('.custom-products-row');
    
    if ($('#activateCustomSubscriptionServices').is(':checked')) {
      // Show custom products table
      $customRow.show();
      // Update button text to "Hide" when showing
      var $icon = $showAllBtn.find('svg');
      $showAllBtn.text('Hide ').append($icon);
    } else {
      // Hide custom products table
      $customRow.hide();
      // Update button text to "Show All" when hiding
      var $icon = $showAllBtn.find('svg');
      $showAllBtn.text('Show All ').append($icon);
    }
    $("#saveChangesBtn").removeAttr("disabled");
  });
  
  // Sticky button functionality
  var saveBtn = document.getElementById('saveChangesBtn');
  
  if (saveBtn) {
    var createObserver = function(stickyEle) {
      var observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              stickyEle.classList.add('fixed');
            } else {
              stickyEle.classList.remove('fixed');
            }
          });
        },
        { root: null, threshold: 0.1, rootMargin: '0px 0px -100px 0px' }
      );
      observer.observe(stickyEle);
      return observer;
    };
    
    var stickySaveObserver = createObserver(saveBtn);
  }
});


// ========================================
// Complete Navigation Blocker for My Alert Preferences
// Blocks ALL navigation types and shows custom modal
// ========================================

(function() {
  'use strict';

  // State management
  let isNavigating = false;
  let pendingNavigationType = null;
  let navigationBlockerInitialized = false;
  let pendingNavigationUrl = null;
  let beforeUnloadBound = false;

  //Check if there are unsaved changes
  //Uses both button state and change tracking variables for accuracy
  function hasUnsavedChanges() {
    // Check change tracking variables (more reliable)
    if (typeof hasProductChanges !== 'undefined' && hasProductChanges) return true;
    if (typeof hasSavedSearchChanges !== 'undefined' && hasSavedSearchChanges) return true;
    
    // Fallback: Check save button state
    const saveBtn = document.getElementById('saveChangesBtn');
    return saveBtn && !saveBtn.hasAttribute('disabled');
  }

  // Show the unsaved changes modal with backdrop (like other lightbox modals)
  function showUnsavedModal() {
    const modal = document.querySelector('.js-unsaved-warning-modal');
    if (!modal) return;
    
    // Add backdrop dynamically (same as other lightbox modals)
    if (!document.querySelector('.lightbox-modal__backdrop')) {
      const $body = $('body');
      $body.addClass('lightboxed');
      const $backdrop = $('<div class="lightbox-modal__backdrop"></div>');
      $body.append($backdrop);
      
      // Close modal when backdrop is clicked (like other lightbox modals)
      $backdrop.off('click').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        cancelNavigation();
      });
    }    
    // Show modal with proper styling
    $(modal).addClass('is-active').css('display', 'block');
  }

  // Hide the unsaved changes modal and remove backdrop
  function hideUnsavedModal() {
    const modal = document.querySelector('.js-unsaved-warning-modal');
    if (modal) {
      $(modal).removeClass('is-active').css('display', 'none');
    }
    
    // Remove backdrop and body class (same as other lightbox modals)
    $('body').removeClass('lightboxed');
    $('.lightbox-modal__backdrop').remove();
  }

  //Handle browser back/forward navigation
  function handlePopState(event) {
    // Allow programmatic navigation
    if (isNavigating) {
      isNavigating = false;
      return;
    }

    // Check for unsaved changes
    if (!hasUnsavedChanges()) {
      return;
    }

    // Block the navigation
    event.preventDefault();
    
    // Determine navigation type
    if (event.state && event.state.blocker) {
      pendingNavigationType = 'external';
    } else if (event.state && event.state.alertPrefsPage) {
      pendingNavigationType = 'back';
    } else {
      pendingNavigationType = 'forward';
    }
    
    // Push state back to cancel navigation
    window.history.pushState(
      { blocker: true, alertPrefsPage: true }, 
      '', 
      window.location.href
    );
    
    // Show custom modal
    showUnsavedModal();
  }

  // Handle page refresh/close - Show browser dialog as fallback
  function handleBeforeUnload(event) {
    if (hasUnsavedChanges() && !isNavigating) {
      // This will show browser's default dialog for refresh/close
      // Unfortunately, custom modal cannot be shown here due to browser security
      event.preventDefault();
      event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      return event.returnValue;
    }
  }

  // Handle all link clicks to show custom modal
  function handleLinkClick(event) {
    // Check if there are unsaved changes
    if (!hasUnsavedChanges() || isNavigating) {
      return;
    }
    const target = event.target.closest('a');
    // Ignore if not a link
    if (!target) {
      return;
    }

    // Ignore modal buttons
    if (target.closest('.js-unsaved-warning-modal') ||
        target.classList.contains('js-unsaved-close-modal') ||
        target.classList.contains('js-unsaved-save-btn') ||
        target.classList.contains('js-unsaved-discard-btn')) {
      return;
    }
    const href = target.getAttribute('href');
    // Ignore empty, hash, or javascript links
    if (!href || href === '#' || href.startsWith('javascript:') || href === '') {
      return;
    }

    // Block the link click
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Store the target URL
    pendingNavigationUrl = href;
    pendingNavigationType = 'link';
    
    // Show custom modal
    showUnsavedModal();
  }

  //Handle form submissions
  function handleFormSubmit(event) {
    // Allow save form to submit
    if (isNavigating) {
      return;
    }

    // Check if it's the save button's form
    const form = event.target;
    const submitButton = document.activeElement;
    
    if (submitButton && submitButton.id === 'saveChangesBtn') {
      return; // Allow save
    }

    // Check for unsaved changes
    if (!hasUnsavedChanges()) {
      return;
    }

    // Block form submission
    event.preventDefault();
    event.stopPropagation();
    
    pendingNavigationType = 'form';
    pendingNavigationUrl = form.action;
    
    // Show custom modal
    showUnsavedModal();
  }

  // Intercept keyboard shortcuts (Ctrl+R, F5, Ctrl+W, etc.)
  function handleKeyDown(event) {
    if (!hasUnsavedChanges() || isNavigating) {
      return;
    }

    // Check for refresh shortcuts
    const isRefresh = (event.key === 'F5') || 
                     (event.ctrlKey && event.key === 'r') ||
                     (event.metaKey && event.key === 'r');
    
    // Check for close tab shortcuts
    const isClose = (event.ctrlKey && event.key === 'w') ||
                   (event.metaKey && event.key === 'w');

    if (isRefresh || isClose) {
      event.preventDefault();
      event.stopPropagation();
      
      pendingNavigationType = isRefresh ? 'refresh' : 'close';
      
      // Show custom modal
      showUnsavedModal();
    }
  }

  //Proceed with the blocked navigation
  function proceedWithNavigation() {
    isNavigating = true;
    
    if (pendingNavigationType === 'link') {
      // Navigate to the stored URL
      if (pendingNavigationUrl) {
        window.location.href = pendingNavigationUrl;
      }
    } else if (pendingNavigationType === 'form') {
      // Submit the form
      if (pendingNavigationUrl) {
        window.location.href = pendingNavigationUrl;
      }
    } else if (pendingNavigationType === 'refresh') {
      // Reload the page
      window.location.reload();
    } else if (pendingNavigationType === 'close') {
      // Close the window/tab
      window.close();
    } else if (pendingNavigationType === 'external' || pendingNavigationType === 'back') {
      // Go back (skip blocker state)
      window.history.go(-2);
    } else if (pendingNavigationType === 'forward') {
      // Go forward
      window.history.go(1);
    }
    
    // Reset
    pendingNavigationType = null;
    pendingNavigationUrl = null;
  }

  //Cancel the navigation and stay on page
  function cancelNavigation() {
    hideUnsavedModal();
    pendingNavigationType = null;
    pendingNavigationUrl = null;
  }

  //Save changes and then navigate
  function saveAndNavigate() {
    // Prevent multiple clicks
    const saveBtn = document.querySelector('.js-unsaved-save-btn');
    if (saveBtn) {
      saveBtn.disabled = true;
    }
    
    // Store pending navigation before save
    const savedPendingUrl = pendingNavigationUrl;
    const savedPendingType = pendingNavigationType;
    
    // Set a flag to prevent auto-reload (we'll navigate manually)
    window.__skipAutoReloadForNavigation = true;
    
    // Trigger the existing save function
    if (typeof submitAllPreferences === 'function') {
      submitAllPreferences()
        .then(function() {
          // Clear the flag
          window.__skipAutoReloadForNavigation = false;
          
          // After successful save, proceed with navigation instead of reload
          isNavigating = true;
          hideUnsavedModal();
          
          // Small delay to ensure save completes
          setTimeout(function() {
            proceedWithNavigation();
          }, 300);
        })
        .catch(function(error) {
          // Clear the flag on error
          window.__skipAutoReloadForNavigation = false;
          console.error('Save failed:', error);
          // Re-enable button on error
          if (saveBtn) {
            saveBtn.disabled = false;
          }
          alert('Failed to save changes. Please try again.');
        });
    } else {
      // Fallback: just navigate if save function not found
      window.__skipAutoReloadForNavigation = false;
      hideUnsavedModal();
      proceedWithNavigation();
    }
  }

  //Initialize all navigation blockers
  function initializeNavigationBlocker() {
    if (navigationBlockerInitialized) return;
    navigationBlockerInitialized = true;

    // Setup history API blocker
    const currentState = window.history.state || {};
    window.history.replaceState(
      { ...currentState, alertPrefsPage: true }, 
      '', 
      window.location.href
    );
    
    window.history.pushState(
      { blocker: true, alertPrefsPage: true }, 
      '', 
      window.location.href
    );

    // Add event listeners
    window.addEventListener('popstate', handlePopState);
    
    if (!beforeUnloadBound) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      beforeUnloadBound = true;
    }
    
    // Capture phase to catch links before any other handler
    document.addEventListener('click', handleLinkClick, true);
    
    // Handle form submissions
    document.addEventListener('submit', handleFormSubmit, true);
    
    // Handle keyboard shortcuts
    document.addEventListener('keydown', handleKeyDown, true);

    console.log('✅ Navigation blocker active - All navigation types blocked');
  }

  //Remove all navigation blockers
  function removeNavigationBlocker() {
    window.removeEventListener('popstate', handlePopState);
    window.removeEventListener('beforeunload', handleBeforeUnload);
    document.removeEventListener('click', handleLinkClick, true);
    document.removeEventListener('submit', handleFormSubmit, true);
    document.removeEventListener('keydown', handleKeyDown, true);
    
    navigationBlockerInitialized = false;
    beforeUnloadBound = false;
    
    console.log('✅ Navigation blocker removed');
  }

   //Setup modal button handlers
   //Uses direct event listeners for better performance and clarity
  function setupModalHandlers() {
    // Save Changes button (in modal only - use class selector to avoid conflict with main save button)
    const modalSaveBtn = document.querySelector('.js-unsaved-warning-modal .js-unsaved-save-btn');
    if (modalSaveBtn) {
      modalSaveBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        saveAndNavigate();
      });
    }

    // Don't Save button
    const discardBtn = document.querySelector('.js-unsaved-discard-btn');
    if (discardBtn) {
      discardBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        hideUnsavedModal();
        proceedWithNavigation();
      });
    }

    // Close/Cancel button (X button)
    const closeBtn = document.querySelector('.js-unsaved-close-modal');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        cancelNavigation();
      });
    }

    // ESC key to close modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        const modal = document.querySelector('.js-unsaved-warning-modal');
        if (modal && $(modal).is(':visible')) {
          cancelNavigation();
        }
      }
    });
  }

  //Monitor for changes to enable/disable blocker
  function monitorChanges() {
    const saveBtn = document.getElementById('saveChangesBtn');
    if (!saveBtn) return;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'disabled') {
          const hasChanges = !saveBtn.hasAttribute('disabled');
          
          if (hasChanges && !navigationBlockerInitialized) {
            initializeNavigationBlocker();
          } else if (!hasChanges && navigationBlockerInitialized) {
            // Optionally remove blocker when no changes
            // removeNavigationBlocker();
          }
        }
      });
    });

    observer.observe(saveBtn, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  //Initialize everything
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Setup modal handlers
    setupModalHandlers();
    
    // Monitor for changes
    monitorChanges();
    
    if (hasUnsavedChanges()) {
      initializeNavigationBlocker();
    }

    console.log('Complete Navigation Blocker initialized');
  }
  init();
})();